<template>
  <div class="product-page">
    <div class="d-flex align-center justify-space-between mb-3">
      <h1 class="my-0">Upsell offers</h1>
      <v-btn color="primary" @click="$router.push({ name: 'website.apps.upsell.create' })">
        <v-icon left>mdi-plus</v-icon>Create offer
      </v-btn>
    </div>
    <p>
      Showing more potential products after your customers add a product to cart or successfully check out, Upsell offer
      has been proven that it may boost conversion rate to 16%. See how it looks or watch video to know how it works.
    </p>
    <Offer />
  </div>
</template>

<script>
import Offer from './components/Offer';
export default {
  components: {
    Offer,
  },
  data() {
    return {
      ids: [],
    };
  },
};
</script>
